import { FormControl, ListItemIcon, ListItemText, MenuItem, SelectChangeEvent } from "@mui/material";
import { FiberManualRecord } from "@mui/icons-material";
import { CaseClientStatus, displayCaseClientStatus } from "Backend";
import theme, { ItemIconSelect } from "theme";
import { useSnackbar } from "notistack";
import { useAppDispatch } from "../../../../redux/hooks";
import { updateCaseClientStatus } from "redux/slices/case";

export interface CaseStatusProps {
  caseId: number;
  status: CaseClientStatus;
}

const CaseStatus = (props: CaseStatusProps) => {
  const { caseId, status } = props;
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useAppDispatch();

  const handleOnChange = async (event: SelectChangeEvent<unknown>) => {
    const status = event.target.value as CaseClientStatus;
    try {
      await dispatch(updateCaseClientStatus({ caseId, status }));
      enqueueSnackbar(`Status set to ${displayCaseClientStatus(status)}`, { variant: "success" });
    } catch (e) {
      enqueueSnackbar("Unable to update status", { variant: "error" });
    }
  };

  return (
    !!status && (
      <FormControl variant="standard">
        <ItemIconSelect
          sx={{
            height: 24,
            "&::before": {
              borderBottom: "none",
            },
          }}
          value={status}
          onChange={handleOnChange}>
          <MenuItem value="active">
            <ListItemIcon style={{ minWidth: 40 }}>
              <FiberManualRecord htmlColor={theme.palette.success.main} />
            </ListItemIcon>
            <ListItemText>Active</ListItemText>
          </MenuItem>
          <MenuItem value="inactive">
            <ListItemIcon style={{ minWidth: 40 }}>
              <FiberManualRecord htmlColor={theme.palette.error.main} />
            </ListItemIcon>
            <ListItemText>Inactive</ListItemText>
          </MenuItem>
        </ItemIconSelect>
      </FormControl>
    )
  );
};

export default CaseStatus;
